import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_i9.png",
      alt: "Estratégias I9 Robôs",
    },
    title: "Opere com Os Vingadores na I9 Robôs!",

    // String ou array de strings
    text: [
      "A I9 robôs nasceu com intuito de distribuir robôs com resultados sólidos e com rentabilidade consistente, com percentuais acima da média do mercado se tratando de renda variável. A gestão de risco de nossos robôs aliado à eficiência do nosso portfólio, pensado nos mais diversos cenários, é o diferencial para os nossos resultados expressivos.",
    ],
    testimonial: {
      text: "Inovação, sinceridade e transparência, são os pilares que sustentam a I9 Robôs.",
      author: {
        name: "Bruno Diniz Guimaraes, fundador e estrategista da I9 Robôs.",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Estratégias portfólio vingadores",
    heading: "Nossos heróis prontos para os trades!",
    subtitle:
      "Estratégias preparadas com múltiplos indicadores, preparadas para trabalhar nos cenários mais diversos ao seu alcance com apenas alguns cliques.",
  },

  cta: {
    title: "Pronto para a experiência dos Vingadores?",
    subtitle: "Ativar Vingadores!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "I9 Robôs",
    col1: [
      "A I9 Robôs foi idealizada para substituir os trades manuais de seus sócios por operações totalmente automatizadas. Levando em consideração o tempo perdido em frente a tela para analisar a entrada nas operações, bem como o fator emocional envolvido em cada operação, decidimos criar os nossos robôs, baseados em nossas diversas estratégias que foram testadas e validadas ao longo de cinco anos.",
      "Hoje nossas operações são 100% automatizadas.",
    ],
    // col2: [
    //   "Utilizando estratégias próprias e profissionais ao longo dos anos conseguimos proporcionar aos traders um melhor acompanhamento das movimentações do mercado e com a automatização  conseguimos potencializar performance, gestão de risco e excluir o fator emocional, assim como otimizar o tempo dos nossos traders.",
    // ],
  },

  stats: {
    title: "Números importantes da I9 Robôs",
    subtitle: "Algumas informações sobre nossos produtos",
    data: [
      {
        value: "+20",
        description: "Robôs desenvolvidos",
      },
      {
        value: "+20k",
        description: "Ordens executadas ao ano",
      },
      {
        value: "+400k",
        description: "Horas de backtest",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da I9?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Você ativa sua estratégia deixa o resto por conta dos vingadores.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte",
        description:
          "Sempre que precisar tirar qualquer dúvida, estaremos à disposição.",
      },
      {
        icon: iconsSet.favorite,
        title: "ZERO Emoção",
        description:
          "Deixe as operações por conta dos robôs. Eles foram programados e testados para o diversos cenários de mercado.",
      },
      {
        icon: iconsSet.balance,
        title: "Transparência Total",
        description: "Honestidade e transparência total com nossos clientes.",
      },
      {
        icon: iconsSet.growth,
        title: "Poder do portfólio",
        description:
          "Nossos robôs possuem estratégias distintas para se equilibrarem e elevarem os percentuais de ganhos.",
      },
      {
        icon: iconsSet.analytics,
        title: "Backtest",
        description:
          "Todas as nossas estratégias são validadas com 5 anos de backtest.",
      },

      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão I9 Robôs",
  },

  testimonials: [
    {
      text: "Uso os Robôs i9 para Day Trade a 2 anos e meio e sou testemunha da evolução destes, tudo a custa de muito estudo e dedicação da I9. Não tenho familiaridade com Day Trade, mesmo sendo Contador, não consigo acompanhar o mercado, com isso deixo os robôs fazerem todo trabalho e estou muito feliz com os resultados que estamos alcançando, mesmo com tantas dificuldades que estamos vivenciando no Brasil. Uso e Recomendo os Robôs i9!",
      author: "Valteir Vaz de Souza",
      job: "Contador",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    // {
    //   text: "Uso os Robôs i9 para Day Trade a 2 anos e meio e sou testemunha da evolução destes, tudo a custa de muito estudo e dedicação da I9. Não tenho familiaridade com Day Trade, mesmo sendo Contador, não consigo acompanhar o mercado, com isso deixo os robôs fazerem todo trabalho e estou muito feliz com os resultados que estamos alcançando, mesmo com tantas dificuldades que estamos vivenciando no Brasil. Uso e Recomendo os Robôs i9!",
    //   author: "Valteir Vaz de Souza",
    //   job: "Contador",
    //   // image_url:
    //   //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    // },
  ],
};
